import { Form, Select } from "antd";

const MultipleSelectField = ({ field }) => (
  <Form.Item
    hidden={field?.hidden}
    key={field.name}
    name={field.name}
    label={field.label}
    extra={field.extra}
    rules={field.rules}
  >
    <Select
      mode="multiple"
      placeholder={`Select ${field.label}`}
      options={field.selectItems?.map((item) => ({
        label: item.label,
        value: item.name,
      }))}
      disabled={field.disabled}
      allowClear
    />
  </Form.Item>
);

export default MultipleSelectField;
